export default __webpack_public_path__ + "static/media/PPI-pools-032.b07308e6.jpg";